import type { ReactNode } from "react";
import { AppLayout } from "./AppLayout";
import { BottomNav } from "../components/BottomNav";

// 하단 탭바 포함 layout — 메인 페이지가 공유
// IA 재편(design doc 2026-05-22-sotda-ia-restructure §2):
//   새 5탭 = home·finance·games·community·my
//   budget·asset·mbti·signature = 금융 탭 하위 (page 값은 accent 분기용으로 유지)
interface Props {
  page:
    | "home" | "finance" | "games" | "community" | "my"
    | "budget" | "asset" | "mbti" | "signature";
  children: ReactNode;
}

export function TabLayout({ page, children }: Props) {
  return (
    <AppLayout page={page}>
      <div className="tab-layout__content">{children}</div>
      <BottomNav />
    </AppLayout>
  );
}
